mutation AddTemplate($zipUrl: String!, $clientId: ID!) {
    addMasterTemplate(temporaryBucketZipPath: $zipUrl, clientId: $clientId) {
        _id
        adType
        persistentKey
    }
}
